// extracted by mini-css-extract-plugin
module.exports = {"icon-wrapper":"styles_icon-wrapper__31AWT","icon-wrapper_active":"styles_icon-wrapper_active__3Gm0l","icon-wrapper_disabled":"styles_icon-wrapper_disabled__3u8GE"};